import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import './ReportTable.css';

const ExitCriteriaStatus = ({ formData, handleExitCriteriaChange }) => {
    const criteriaRows = [
        { key: 'allPlannedExecuted', label: 'All planned test cases executed' },
        { key: 'allCriticalHighClosed', label: 'All Critical & High defects closed' },
        { key: 'regressionCompleted', label: 'Regression testing completed' },
        { key: 'stabilityVerified', label: 'Build stability verified' },
        { key: 'summaryPrepared', label: 'Test summary prepared' },
        { key: 'stakeholderReviewCompleted', label: 'Stakeholder review completed' }
    ];

    return (
        <Stack spacing={3}>
            <MaterialTypography variant="h6" fontWeight="bold">
                Exit Criteria Status
            </MaterialTypography>
            <div className="report-table-container">
                <table className="report-table">
                    <tbody>
                        {criteriaRows.map((row) => (
                            <tr key={row.key}>
                                <td style={{ width: '40%', fontWeight: '500' }}>{row.label}</td>
                                <td>
                                    <MaterialInput
                                        size="small"
                                        value={formData.exitCriteria[row.key]}
                                        placeholder="Status/Comments"
                                        onChange={(e) => handleExitCriteriaChange(row.key, e.target.value)}
                                        fullWidth
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Stack>
    );
};

export default ExitCriteriaStatus;
